import { useEffect, useState } from "react";
import billingService from "../../services/billingService";
import { VoucherTypeFormat } from "../../models/EnumEntity";
import { utils } from "../../utils/utils";

const mapVoucher = (voucher) => {
    if (!voucher) return null
    return {
        ...voucher,
        typeToShow: VoucherTypeFormat[voucher.type],
        customer: voucher.customer,
        items: voucher?.items.map(i => ({
            ...i,
            amountToShow: utils.formatMoney(i.amount),
            priceToShow: utils.formatMoney(i.price)
        }))
    }
}
const useVoucher = (voucherId) => {
    const [voucher, setVoucher] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getFromServer = async () => {
            setLoading(true)
            billingService
                .GetVoucher(voucherId)
                .then(res => setVoucher(mapVoucher(res)))
                .finally(setLoading(false))
        }

        if (voucherId) getFromServer()
    }, [voucherId])

    return {
        voucher,
        loading
    }
}

export default useVoucher;